export const defaultUrl = process.env.REACT_APP_SERVER_URL
export const serverUrl = process.env.REACT_APP_LISTENER_URL

export const multitenantBaseURL = "/api/MultiTenant";

export const multitenantRoutes = {
  login : `${multitenantBaseURL}/Login`,
  logout : `${multitenantBaseURL}/Logout`,  
  allTenants : `${multitenantBaseURL}/AllTenantsWithOrganization`,
  saveTenant : `${multitenantBaseURL}/TenantInfo`,
  updateTenant : `${multitenantBaseURL}/UpdateTenantInfo`,
  deleteTenant : `${multitenantBaseURL}/DeleteTenantInfo`,
  getOrganizations : `${multitenantBaseURL}/GetOrganizations`,
  organizations : `${multitenantBaseURL}/Organization`,
  addOrganization : `${multitenantBaseURL}/Organization`,
  checkMultiTenantDb : `${multitenantBaseURL}/CheckMultiTenantRepoExistence`,
  setupMultiTenantDbAndDefaultTenant : `${multitenantBaseURL}/AddMultiTenantRepoAndDefaultTenant`,
  GetAllUsers: `${multitenantBaseURL}/GetAllUsers`,
  AddUser: `${multitenantBaseURL}/AddUser`,
  AuthenticateAzureUser: `${multitenantBaseURL}/AuthenticateAzureUser`,
  GetMonolithInfo: `${serverUrl}/api/GetMonolithInfo`,
  UpgradeReposForAllTenants : `${multitenantBaseURL}/UpgradeAllTenantsRepo`,
  getExceptions : `${multitenantBaseURL}/Exceptions`,
  deleteUser : `${multitenantBaseURL}/DeleteCloudPortalUser`
};

export const baseServerApiURL = "api"

export const dbAgentBaseUrl = `${baseServerApiURL}/db`

export const dbAgentRoutes = {
    dbProviders : `${dbAgentBaseUrl}/DbProviders`,
    getDabases : `${dbAgentBaseUrl}/GetDatabases`
}


